import { loginByPhone } from "@/api/login";
import { loginByPhoneAndCode, whoami } from "../../api/login";
import { connect, disconnect } from "../../api/ws";

const emptyState = {
  id: "",
  name: "",
  phone: "",
  avatar: "",
  download: "",
  upload: "",
  roles: [],
  permissions: [],
};

const user = {
  state: {
    ...emptyState,
  },

  mutations: {
    SET_ID: (state, id) => {
      state.id = id;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone;
    },
    SET_DOWNLOAD: (state, download) => {
      state.download = download;
    },
    SET_UPLOAD: (state, upload) => {
      state.upload = upload;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions;
    },
    CLEAR_USER: (state) => {
      Object.assign(state, emptyState);
    },
  },

  getters: {
    getUserInfo: (state) => {
      return {
        id: state.id,
        name: state.name,
        phone: state.phone,
        download: state.download,
        upload: state.upload,
        avatar: state.avatar,
      };
    },
  },

  actions: {
    // 通过手机号登录
    LoginByPhone({ commit }, userInfo) {
      const phoneNumber = userInfo.phoneNumber.trim();
      return new Promise((resolve, reject) => {
        loginByPhone({
          phone: phoneNumber,
        })
          .then((res) => {
            console.log(res);
            commit("SET_ID", res.data.userId);
            // commit('SET_TOKEN', res.token)
            commit("SET_NAME", res.data.userName);
            commit("SET_PHONE", res.data.phone);
            commit("SET_DOWNLOAD", res.data.download);
            commit("SET_UPLOAD", res.data.upload);
            commit("SET_AVATAR", res.data.imageUrl);
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 通过手机号登录
    LoginByPhoneAndCode({ commit }, userInfo) {
      console.log(userInfo);
      const phoneNumber = userInfo.phone.trim();
      const phoneCode = userInfo.code.trim();
      return new Promise((resolve, reject) => {
        loginByPhoneAndCode(phoneNumber, phoneCode)
          .then((res) => {
            console.log(res);
            localStorage.setItem("token", res.data.token);
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    WhoAmI({ commit }) {
      return new Promise((resolve, reject) => {
        whoami()
          .then((res) => {
            commit("SET_ID", res.data.userId);
            commit("SET_NAME", res.data.userName);
            commit("SET_PHONE", res.data.phone);
            commit("SET_DOWNLOAD", res.data.download);
            commit("SET_UPLOAD", res.data.upload);
            commit("SET_AVATAR", res.data.imageUrl);

            connect(res.data.userId);
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 退出系统
    // LogOut({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     logout(state.token).then(() => {
    //       commit('SET_TOKEN', '')
    //       commit('SET_ROLES', [])
    //       commit('SET_PERMISSIONS', [])
    //       removeToken()
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 前端 登出
    LogOut({ commit }) {
      return new Promise((resolve) => {
        commit("CLEAR_USER");
        disconnect();
        localStorage.removeItem("token");
        resolve();
        console.log("退出登录");
      });
    },
  },
};

export default user;
